import { render } from "./SubmissionView.vue?vue&type=template&id=809b6f80"
import script from "./SubmissionView.vue?vue&type=script&lang=js"
export * from "./SubmissionView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__